import * as React from 'react'
import styled from 'styled-components'

interface HeadingTwoProps {
  className?: string
  children: React.ReactNode
}

const
  HeadingTwoText = styled.h2`
    align-items: center;
    font-size: 1.58rem; // rem math: 47.47px / 2 / 15px 
    color: ${p => p.theme.colors.headingText};
    ${p => p.theme.headingFont}
  `,
  HeadingTwo: React.FC<HeadingTwoProps> = ({ className, children }) => {
    return (
      <HeadingTwoText className={className}>
        {children}
      </HeadingTwoText>
    )
  }

export default HeadingTwo
